import React from "react";
import { useSelector } from "react-redux";

import { Container, Grid } from "semantic-ui-react";
import { cartSelector } from "../../utils/selectors";
import CheckoutProgress from "../../components/CheckoutProgress";
import ItemsList from "./ItemsList";
import TableTitle from "./TableTitle";
import PaymentActions from "./PaymentActions";
import { FormattedMessage } from "react-intl";

const Cart = () => {
  const cart = useSelector((state) => cartSelector(state));

  return (
    <Container>
      <TableTitle
        items={cart.length}
        text={
          <FormattedMessage id={"cart.title"} defaultMessage={"Your cart"} />
        }
      />
      <Grid.Row>
        <Grid.Column widescreen={6} computer={8} mobile={16} tablet={16}>
          <CheckoutProgress active={"cart"} />
        </Grid.Column>
      </Grid.Row>
      <Grid columns={2} padded={"vertically"}>
        <Grid.Column mobile={16} tablet={10} computer={10} widescreen={10}>
          {cart && <ItemsList items={cart} type={"cart"} />}
        </Grid.Column>
        <Grid.Column mobile={16} tablet={6} computer={6} widescreen={6}>
          <PaymentActions />
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default Cart;
